import type { Auction, Bid, Comment, User } from "./types";

export async function fetchAuctions(): Promise<Auction[]> {
	const res = await fetch("/api/auctions");
	return res.json();
}

export async function fetchAuction(id: string): Promise<Auction> {
	const res = await fetch(`/api/auctions/${id}`);
	if (!res.ok) throw new Error("Auction not found");
	return res.json();
}

export async function createAuction(data: {
	title: string;
	description: string;
	category: string;
	budget: number;
	deadlineHours: number;
	buyerId: string;
}): Promise<Auction> {
	const res = await fetch("/api/auctions", {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(data),
	});
	return res.json();
}

export async function submitBid(
	auctionId: string,
	data: { providerId: string; amount: number; message: string }
): Promise<Bid> {
	const res = await fetch(`/api/auctions/${auctionId}/bids`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(data),
	});
	if (!res.ok) throw new Error("Failed to submit bid");
	return res.json();
}

export async function submitComment(
	auctionId: string,
	data: { authorId: string; text: string; parentId: string | null }
): Promise<Comment> {
	const res = await fetch(`/api/auctions/${auctionId}/comments`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(data),
	});
	return res.json();
}

export async function fetchUsers(): Promise<User[]> {
	const res = await fetch("/api/users");
	return res.json();
}
